<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>货品管理</el-breadcrumb-item>
                <el-breadcrumb-item>入库临时信息</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="120px" :model="query" class="search-form">
            <el-row>
                <el-form-item label="关键词" prop="keyword">
                    <el-col style="width: 220px">
                        <el-input v-model="query.keyword" prefix-icon="Search" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="操作类型" prop="billType">
                    <el-col>
                        <el-select v-model="billType" placeholder="请选择操作类型" clearable @change="fetchs()" style="width: 140px">
                            <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>

                <el-form-item label="单据时间">
                    <el-col>
                        <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
                            unlink-panels @change="fetchs()" :shortcuts="$util.getShortCuts()"> </el-date-picker>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="系统款号" prop="detailCode">
                    <el-col style="width: 220px">
                        <el-input v-model="detailCode" @keyup.enter="fetchs"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="批次号" prop="serialCode">
                    <el-col>
                        <el-input v-model="serialCode" @keyup.enter="fetchs" style="width: 140px"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="品牌批次号" prop="brandSerialCode">
                    <el-col>
                        <el-input v-model="brandSerialCode" @keyup.enter="fetchs" style="width: 140px"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="规格" prop="unitName">
                    <el-col>
                        <el-input v-model="unitName" @keyup.enter="fetchs" style="width: 100px"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="金重(g)" prop="goldWeight">
                    <el-col>
                        <el-input type="number" v-model="goldWeight" @keyup.enter="fetchs" autocomplete="off"
                            style="width: 100px"></el-input>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="所属公司">
                    <el-col>
                        <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs();" clearable
                            check-strictly :render-after-expand="false" style="min-width: 220px;" />
                    </el-col>
                </el-form-item>
                <el-form-item label="所在库房">
                    <el-col>
                        <el-select v-model="storeCode" placeholder="库房" clearable @change="fetchs()" style="width: 140px">
                            <el-option v-for="item in dict.stores" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="所在渠道">
                    <el-col>
                        <el-select v-model="channel" placeholder="渠道" clearable @change="fetchs()" style="width: 140px">
                            <el-option v-for="item in dict.channels" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>

                <el-form-item label="" label-width="60px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="download" @click="exportEvent()">明细导出</el-button>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:billType="scope">
                {{ scope.row.billType }}
            </template>

            <template v-slot:billCode="scope">
                <el-link type="success" size="small" :underline="false" @click="openBillPage(scope.row)">{{ scope.row.billCode
                }}</el-link>
            </template>

            <template v-slot:detailImg="scope">
                <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                    :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                    <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                </el-image>
            </template>

            <template v-slot:detailCode="scope">
                <el-link type="success" size="small" :underline="false" :href="'?detailCode=' + scope.row.detailCode">{{
                    scope.row.detailCode }}</el-link>
            </template>

            <template v-slot:serialCode="scope">
                {{ scope.row.serialCode || '' }}
            </template>

            <template v-slot:brandSerialCode="scope">
                {{ scope.row.brandSerialCode || '' }}
            </template>

            <template v-slot:productionDate="scope">
                {{ (scope.row.productionDate || '').split(' ')[0] }}
            </template>

            <template v-slot:warrantyExpiryDate="scope">
                <el-tag v-if="scope.row.warrantyExpiryDate" :type="new Date(scope.row.warrantyExpiryDate) < new Date() ? 'danger'
                    : new Date(scope.row.warrantyExpiryDate) - new Date() <= 183 * 24 * 60 * 60 * 1000 ? 'warning'
                        : new Date(scope.row.warrantyExpiryDate) - new Date() <= 365 * 24 * 60 * 60 * 1000 ? 'primary'
                            : 'success'
                    " disable-transitions>
                    {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
                </el-tag>
            </template>

            <template v-slot:status="scope">
                <el-tag v-if="scope.row.status === '1'" type="success">已审核</el-tag>
                <el-tag v-else-if="scope.row.status === '0'" type="warning">待审核</el-tag>
                <el-tag v-else-if="scope.row.status === '-1'" type="info">已取消</el-tag>
                <el-tag v-else type="info">{{ scope.row.status }}</el-tag>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import BasicTable from "@/components/basic-table.vue";

export default {
    name: "StockBoundTemp",
    components: { BasicTable },
    data() {
        return {
            apiUrl: "",
            dateRange: null,
            billType: '',
            detailCode: "",
            serialCode: "",
            brandSerialCode: "",
            unitName: '',
            goldWeight: '',
            companyId: '',
            storeCode: null,
            channel: null,
            query: {
                keyword: "",
                filters: [],
                columns: [
                    { type: "selection", width: "55" },
                    { type: "index", label: "序号" },
                    { type: "template", prop: "billType", label: "单据类型", width: "70", searchable: true, showOverflowTooltip: true },
                    { prop: "storeCode", label: "库房", sortable: true, searchable: true, width: "75", showOverflowTooltip: true, align: "center" },
                    { type: "template", prop: "billCode", label: "单据编号", width: "100", searchable: true, showOverflowTooltip: true },
                    { prop: "channel", label: "渠道", sortable: true, searchable: true, width: "68", showOverflowTooltip: true },
                    { type: "template", prop: "detailCode", label: "款号", sortable: true, searchable: true, showOverflowTooltip: true, width: "110" },
                    { prop: "brandModelCode", label: "品牌款号", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
                    { prop: "detailName", label: "名称", sortable: true, searchable: true, width: "170", showOverflowTooltip: true },
                    { type: "template", prop: "detailImg", label: "图片", width: "50" },
                    { type: "template", prop: "serialCode", label: "批次号", sortable: true, searchable: true, showOverflowTooltip: true, width: "100" },
                    { prop: "weight", label: "总重(g)", width: "65", showOverflowTooltip: true, align: "center" },
                    { prop: "goldWeight", label: "金重(g)", width: "90", sortable: true, showOverflowTooltip: true, align: "center" },
                    { type: "template", prop: "brandSerialCode", label: "品牌批次号", sortable: true, searchable: true, showOverflowTooltip: true, width: "105" },
                    { prop: "stockNumber", label: "操作数", width: "65", align: "center" },
                    { prop: "stockRemain", label: "库存数", sortable: true, width: "80", showOverflowTooltip: true, align: "center" },
                    { prop: "unitName", label: "规格", width: "70", sortable: true, searchable: true, showOverflowTooltip: true },
                    { prop: "goldInPrice", label: "金单价(元/g)", showOverflowTooltip: true, width: "90", align: "right" },
                    { prop: "laborUnitPrice", label: "克工费", showOverflowTooltip: true, width: "65", align: "right" },
                    { prop: "laborPiecePrice", label: "件工费", showOverflowTooltip: true, width: "65", align: "right" },
                    { prop: "otherPiecePrice", label: "其他费用", showOverflowTooltip: true, width: "65", align: "right" },
                    { prop: "stoneBoundPrice", label: "镶嵌物费用", showOverflowTooltip: true, width: "90", align: "right" },
                    { prop: "purchasePrice", label: "采购价", sortable: true, showOverflowTooltip: true, width: "80", align: "right" },
                    { prop: "useBrandPrice", label: "品牌使用费", showOverflowTooltip: true, width: "90", align: "right" },
                    { prop: "productPrice", label: "入库价", sortable: true, showOverflowTooltip: true, width: "80", align: "right", fixed: "right" },
                    { prop: "labelPrice", label: "标签价", showOverflowTooltip: true, width: "60", align: "right" },
                    { prop: "sellPrice", label: "计划售价", showOverflowTooltip: true, width: "65", align: "right" },
                    { prop: "certNumber", label: "证书号", sortable: true, searchable: true, showOverflowTooltip: true, width: "100" },
                    // { prop: "stockDate", label: "单据时间", sortable: true, width: "140", showOverflowTooltip: true },
                    { prop: "factoryCode", label: "供应商", sortable: true, searchable: true, showOverflowTooltip: true, width: "80" },
                    { prop: "platformName", label: "平台名称", searchable: true, showOverflowTooltip: true, width: "80" },
                    { prop: "platformOrderNo", label: "平台单号", sortable: true, searchable: true, showOverflowTooltip: true, width: "160" },
                    { prop: "receiverName", label: "收货人", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "receiverMobile", label: "收货手机号", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
                    { prop: "outOrderNo", label: "原单号", sortable: true, searchable: true, showOverflowTooltip: true, width: "120" },
                    { prop: "remark", label: "备注", sortable: true, searchable: true, showOverflowTooltip: true, width: "150" },
                    { prop: "stockReason", label: "日志", sortable: true, searchable: true, showOverflowTooltip: true, width: "150" },
                    { type: "template", prop: "productionDate", label: "生产日期", sortable: true, width: "90" },
                    { type: "template", prop: "warrantyExpiryDate", label: "有效日期", sortable: true, width: "100" },
                    { prop: "createDate", label: "创建时间", sortable: true, width: "140" },
                    { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "85" },
                    { prop: "updateDate", label: "更新时间", sortable: true, width: "140" },
                    { prop: "updateUserName", label: "更新人", sortable: true, searchable: true, width: "85" },
                    { type: "template", prop: "status", label: "状态", sortable: true, width: "90", fixed: "right" }
                ],
                sidx: "id",
                sord: "desc",
            },
            companys: [],
            dict: {
                inBillTypes: [],
                outBillTypes: [],
                billTypes: [],
                stores: [],
                channels: []
            }
        };
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        
        // kaung插件初始化
        this.$kaung.init(this.$options.name);
        
        // 获取公司列表
        this.$kaung.companys().then((res) => {
            this.companys = res;
        });

        // 获取字典数据
        this.$kaung.dictionary("stock", "inbound").then(res => {
            this.dict.inBillTypes = res;
            this.$kaung.dictionary("stock", "outbound").then(res => {
                this.dict.outBillTypes = res;
                this.dict.billTypes = this.dict.inBillTypes.concat(this.dict.outBillTypes);
            });
        });
        this.$kaung.dictionary("stock", "store").then(res => this.dict.stores = res);
        this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res);

        // 从URL参数获取搜索条件
        this.detailCode = this.$route.query.detailCode || '';
        this.serialCode = this.$route.query.serialCode || '';
        this.brandSerialCode = this.$route.query.brandSerialCode || '';

        // 从本地存储获取公司ID
        this.companyId = this.$util.getLocalstorage('companyIdStr');

        this.fetchs();
    },
    methods: {
        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            
            if (this.dateRange && this.dateRange[0]) {
                params.filters.push({
                    name: "createDate",
                    value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"),
                    operate: 2
                });
            }
            if (this.dateRange && this.dateRange[1]) {
                params.filters.push({
                    name: "createDate",
                    value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59",
                    operate: 3
                });
            }

            if (this.detailCode) {
                params.filters.push({
                    name: "detailCode",
                    value: "%" + this.detailCode + "%",
                    operate: 5
                });
            }
            if (this.serialCode) {
                params.filters.push({
                    name: "serialCode",
                    value: "%" + this.serialCode + "%",
                    operate: 5
                });
            }
            if (this.brandSerialCode) {
                params.filters.push({
                    name: "brandSerialCode",
                    value: "%" + this.brandSerialCode + "%",
                    operate: 5
                });
            }
            if (this.unitName) {
                params.filters.push({
                    name: "unitName",
                    value: "%" + this.unitName + "%",
                    operate: 5
                });
            }
            if (this.goldWeight && this.goldWeight > 0) {
                params.filters.push({
                    name: "goldWeight",
                    value: this.goldWeight,
                    operate: 0
                });
            }

            // 所属公司
            if (this.companyId && this.companyId.length > 0) {
                params.filters.push({
                    name: "companyId",
                    value: this.companyId,
                    operate: 6
                });
            }
            // 库房
            if (this.storeCode) {
                params.filters.push({
                    name: "storeCode",
                    value: this.storeCode,
                    operate: 0
                });
            }
            // 渠道
            if (this.channel) {
                params.filters.push({
                    name: "channel",
                    value: this.channel,
                    operate: 0
                });
            }
            // 单据类型
            if (this.billType) {
                params.filters.push({
                    name: "billType",
                    value: this.billType,
                    operate: 0
                });
            }

            return params;
        },
        fetchs() {
            let params = this.builder();
            this.$kaung.search(params).then((res) => {
                this.query = { ...res.data };
            });
        },
        exportEvent() {
            let params = this.builder();
            this.$kaung.export(params).then((res) => {
                this.$notify({
                    title: '表格数据导出',
                    message: res.content,
                    type: res.type,
                    duration: 10000
                });
                window.location.href = process.env.VUE_APP_BASEURL + res.data;
            });
        },
        openBillPage(bill) {
            let inOptions = this.dict.inBillTypes.filter(function (item) {
                return item.name == bill.billType;
            });
            if (bill.billType.indexOf('借货') > -1) {
                this.$router.push("/stock/bills/borrowDetail?billCode=" + bill.billCode);
            }
            else if (inOptions && inOptions.length > 0) {
                this.$router.push("/stock/bills/indetail?billCode=" + bill.billCode);
            } else {
                this.$router.push("/stock/bills/detail?billCode=" + bill.billCode);
            }
        }
    },
    watch: {
        companyId: function (newValue, oldValue) {
            if (newValue && newValue != oldValue)
                this.$util.setLocalstorage('companyIdStr', newValue);
            else
                this.$util.setLocalstorage('companyIdStr', '');
        }
    }
};
</script>

<style lang="less" scoped>
.el-form .el-date-editor {
    width: 220px;
}

.el-link {
    font-size: 0.8em;
}
</style>
